module.exports = __webpack_public_path__ + "img/wisdom_1.7ff3a28a.png";